import { DeleteOutlined, LockOutlined, SaveOutlined, PlusCircleOutlined } from '@ant-design/icons';
import Confirmation from '@app/common/Confirmation';
import { Can } from '@app/modules/Auth';
import { Col, Card, Form, Button, Row, Select, Input, Checkbox, Statistic } from 'antd';
import React, { useMemo } from 'react';

const BuildingForm = ({
  listBuilds,
  handleBuildingDelete,
  selBuild,
  handleBuildingsEdit,
  handleBuildAdd,
  handleBuildChange,
  handleBuildingNameChange,
  handleBuildingEUIChange,
  useMainProfileBuild,
  handleCheck2,
  buildProfChanged,
  profileItems,
  selBuildLevelsCount,
  selBuildRoomsCount
}) => {
  const buildItems = useMemo(() => {
    return listBuilds?.map(building => (
      <Select.Option key={building.id} value={building.id} id={building.id}>
        {building.name}
      </Select.Option>
    ));
  }, [listBuilds]);

  return (
    <Col span={12}>
      <Card
        className="card-stats"
        title={`Buildings list ${listBuilds.length} buildings`}
        actions={[
          <Form.Item className="actions">
            <Can
              action="delete:buildings"
              yes={close => (
                <Confirmation
                  onOk={async close => {
                    await handleBuildingDelete();
                    close();
                  }}
                  content={`Delete this building ? `}
                  title={`Confirm delete operation`}
                >
                  {open => (
                    <Button
                      type="primary"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => open()}
                      className="btn btn-danger"
                      disabled={!selBuild?.id}
                    >
                      Delete
                    </Button>
                  )}
                </Confirmation>
              )}
              no={() => (
                <Button type="primary" danger disabled icon={<LockOutlined />}>
                  Delete
                </Button>
              )}
            />
            <Can
              action="put:buildings"
              yes={() => (
                <Button disabled={!selBuild?.id} type="primary" onClick={handleBuildingsEdit} icon={<SaveOutlined />}>
                  Save
                </Button>
              )}
              no={() => (
                <Button type="primary" disabled icon={<LockOutlined />}>
                  Save
                </Button>
              )}
            />
            <Can
              action="post:buildings"
              yes={() => (
                <Button onClick={handleBuildAdd} className="btn btn-success" icon={<PlusCircleOutlined />}>
                  Add
                </Button>
              )}
              no={() => (
                <Button className="btn btn-success" disabled icon={<LockOutlined />}>
                  Add
                </Button>
              )}
            />
          </Form.Item>
        ]}
      >
        <Row>
          <Col lg={24} md={24}>
            <Form.Item className="vertical-select" label="Select building:">
              <Select id="buildsList" size="middle" value={'' || selBuild?.id} onChange={handleBuildChange}>
                {buildItems}
              </Select>
            </Form.Item>
            <Form.Item className="input-field" rules={[{ required: true }]} label="Building name:">
              <Input type="text" id="buildName" value={selBuild.name || ''} onChange={handleBuildingNameChange} />
            </Form.Item>
            <Can
              action="patch:buildings"
              yes={() => (
                <>
                  <Form.Item className="input-field" label="EUI:">
                    <Input
                      type="number"
                      min="150"
                      max="800"
                      value={selBuild?.eui || ''}
                      onChange={handleBuildingEUIChange}
                      id="EUI"
                    />
                  </Form.Item>
                </>
              )}
              no={() => (
                <>
                  <Form.Item className="input-field pt-20" label="EUI:">
                    <Input type="number" value={selBuild?.eui} disabled />
                  </Form.Item>
                </>
              )}
            />
            <Form.Item className="input-checkbox" label="Use main profile for all rooms">
              <Checkbox id="check2" checked={useMainProfileBuild} onChange={handleCheck2} />
            </Form.Item>
            {useMainProfileBuild && (
              <Form.Item className="select-profile" label="Energy profile:">
                <Select id="buildingProfile" size="middle" value={selBuild.defProf} onChange={buildProfChanged}>
                  {profileItems}
                </Select>
              </Form.Item>
            )}
            <Row gutter={16} className="pt-20">
              <Col span={8}>
                <Statistic title="Levels:" value={selBuildLevelsCount} />
              </Col>
              <Col span={8}>
                <Statistic title="Rooms:" value={selBuildRoomsCount} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};
export default BuildingForm;
